import { OrderActionType } from 'enums/modules/order/orderActionType';
import { OrderType } from 'enums/modules/order/orderType';
import { OrderDetail } from 'model/modules/orders/orderDetail';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapOrderStatusFromApi from './mapOrderStatusFromApi';

const mapOrderDetailFromApi = (
  resp: SharesproApiResponse<ApiOrderDetailResponse>
): OrderDetail => {
  return {
    id: resp.data.id,
    name: resp.data.full_name,
    ticker: resp.data.ticker ?? '',
    openedPositionQuantity: resp.data.open_position_quantity,
    amount: resp.data.amount,
    action: resp.data.action as OrderActionType,
    status: mapOrderStatusFromApi(resp.data.status),
    type: (resp.data.type as OrderType) ?? null,
    expiration: resp.data.expiration ?? null,
    createdAt: new Date(resp.data.create_timestamp * 1000),
    quantityAfterClose: resp.data.quantity_after_close,
    currency: resp.data.currency,
    quantity: resp.data.quantity_precision,
    isAllowConfirm: resp.data.is_allow_confirm,
    isAllowCancel: resp.data.is_allow_cancel,
    description: resp.data.description,
  };
};

export default mapOrderDetailFromApi;
